import { useQuery } from "@tanstack/react-query"

import axios from "axios"

import usePageConfig from "Pods/Shared/Hooks/usePageConfig"
import { useThreeDStudioStore } from "Pods/ThreeDStudio/Store"

export const BACKGROUND_IMAGES_QUERY_KEY = ["generatorBackgroundImages"]
export const BACKGROUND_IMAGES_ENDPOINT = "/api/internal/generator/background_images"
const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000

export async function fetchBackgroundImages() {
  const { data } = await axios.get(BACKGROUND_IMAGES_ENDPOINT)
  return data?.data ?? []
}

function useBackgroundImages() {
  const { isCurrentUser: isLoggedIn } = usePageConfig() || {}
  const isModelLoaded = useThreeDStudioStore(state => Boolean(
    state.ui?.openedModel?.outputAssets?.[0]?.fileUrl
    || state.modelSettings?.inputThreeDUrl,
  ))
  const isEnabled = Boolean(isLoggedIn) && isModelLoaded

  const { data, isLoading, isError } = useQuery({
    queryKey: BACKGROUND_IMAGES_QUERY_KEY,
    queryFn: fetchBackgroundImages,
    enabled: isEnabled,
    staleTime: ONE_DAY_IN_MS,
  })

  return {
    images: data ?? [],
    isLoading: isEnabled && isLoading,
    isError,
  }
}

export default useBackgroundImages
